module.exports = require("querystring");